import type { CreateErrorBannerParams, CreateSuccessBannerParams } from './types';

export function createSuccessBanner({
	petitionId,
	translate,
	setBannerDismissed,
	addBanner,
}: CreateSuccessBannerParams): void {
	const successBannerKey = `free-promotion-action-success-${petitionId}`;
	addBanner({
		message: translate('corgi.petition.starter_dashboard.notifications.free_promo.response_options.success'),
		severity: 'success',
		dismissable: true,
		onClose: () => {
			setBannerDismissed(successBannerKey);
		},
	});
}

export function createErrorBanner({
	petitionId,
	translateHtml,
	setBannerDismissed,
	addBanner,
}: CreateErrorBannerParams): void {
	const errorBannerKey = `free-promotion-action-error-${petitionId}`;
	addBanner({
		message: translateHtml('corgi.petition.starter_dashboard.notifications.free_promo.response_options.error'),
		severity: 'critical',
		dismissable: true,
		onClose: () => {
			setBannerDismissed(errorBannerKey);
		},
	});
}
